import { useEffect, useState, useContext, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { AppContext } from '../../context/AppContext';
import HistoryBackIcon from '../../assets/icon-google-backwards.svg?react';
import NewChatIcon from '../../assets/icon-topic.svg?react';
import './style.scss';
import { ChatHistoryComponent } from './ChatHistoryComponent';
import OverlayTooltip from './UI/OverlayTooltip';
import AppStoreIcon from '../../assets/icon-app-dashboard.svg?react';
import { useNavigate } from 'react-router-dom';
import useElysiaStore from '@/app/elysia-store';
import FavouriteAppList from './FavouriteAppList';

const ChatHistorySidebar = (props) => {
  const { startNewTopicChat } = props;
  const { isSideNavOpen, setIsSideNavOpen } = useContext(AppContext);
  const isPrivateChat = useElysiaStore((state) => state.isPrivateChat);
  const isChatDisabled = useElysiaStore((state) => state.isChatDisabled);
  const isAppFileAttached = useElysiaStore((state) => state.isAppFileAttached);
  const brandDoc = useElysiaStore((state) => state.brandDoc);

  const [pathSession_id, setPathSession_id] = useState('');
  const locationPath = window.location.pathname;
  let pathname = '';
  const newChatRef = useRef<HTMLButtonElement | null>(null);
  const navigate = useNavigate();

  if (locationPath.indexOf('/session/') !== -1) {
    pathname = locationPath.substring(locationPath.lastIndexOf('/') + 1);
  }

  useEffect(() => {
    setPathSession_id(pathname);

    // close side navbar for smaller screens
    if (window.innerWidth < 960) {
      setIsSideNavOpen(false);
    }
    // eslint-disable-next-line
  }, [pathname]);

  useEffect(() => {
    if (isSideNavOpen && newChatRef.current) {
      newChatRef.current.focus();
    }
    // eslint-disable-next-line
  }, [isSideNavOpen, newChatRef.current]);

  const handleNewChatClick = () => {
    if (window.innerWidth < 1260) {
      setIsSideNavOpen(false);
    }
    startNewTopicChat();
  };

  const handleAppDashboard = () => {
    if (window.innerWidth < 1260) {
      setIsSideNavOpen(false);
    }
    navigate('/app-store');
  };

  return (
    <>
      <div className={'menu-fixed-top' + (isSideNavOpen ? '' : ' d-none')}>
        <Button
          data-testid="new-chat-button"
          className="new-chat-button fw-semibold"
          onClick={handleNewChatClick}
          ref={newChatRef}
          disabled={isAppFileAttached && isChatDisabled && brandDoc}
        >
          <NewChatIcon />
          <span>New Chat</span>
        </Button>

        <Button
          data-testid="brnad-agent-button"
          className="new-chat-button fw-semibold mt-4"
          onClick={handleAppDashboard}
        >
          <AppStoreIcon />
          <span>AI App Store</span>
        </Button>

        {/* Favourite App List */}
        <FavouriteAppList setIsSideNavOpen={setIsSideNavOpen} />

        <div className="chat-history-title-wrapper d-flex align-items-center justify-content-between">
          <span className={'fw-semibold' + (isPrivateChat ? ' private-chat-mode' : '')}>
            Chat History
          </span>
          <OverlayTooltip
            tooltipText="Close Panel"
            buttonContent={<HistoryBackIcon />}
            ariaLabel="back"
            testId="back-button"
            tooltipClassName="tooltip-sidebar"
            buttonClassName="back-icon-button"
            onClick={() => setIsSideNavOpen(!isSideNavOpen)}
          />
        </div>
      </div>
      <div
        className={
          'menu-scrollable flex-grow-1 overflow-auto' +
          (isSideNavOpen ? '' : ' d-none') +
          (isPrivateChat ? ' private-chat-mode' : '')
        }
      >
        <ChatHistoryComponent
          pathSession_id={pathSession_id}
          setPathSession_id={setPathSession_id}
        />
      </div>
      <div
        className={
          'menu-fixed-bottom' +
          (isSideNavOpen ? '' : ' d-none') +
          (isPrivateChat ? ' private-chat-mode' : '')
        }
      >
        <div className="archive-msg" data-testid="archive-message-text">
          Archive your chats to keep beyond 30 days
        </div>
      </div>
    </>
  );
};

export default ChatHistorySidebar;
